jQuery(document).ready(function () {
    jQuery("#load-more-posts").click(function () {
        var input = jQuery(this);
        var container = jQuery("#posts-container");
        var offset = container.data("offset");
        if (offset < 0) {
            return;
        }

        input.addClass("loading-upper");
        container.addClass("loading");

        data = {
            action: "kt_grd_load_more_posts",
            kt_offset: offset,
            kt_category_id: container.data("category-id"),
            kt_events_state_id: container.data("events-state-id")
        };

        jQuery.post(myAjax.ajaxurl, data, function (response) {
            if (response == null || response == false) { // empty
                input.css("display", "none");
            } else if (response.indexOf("<p") == 0) { // no results
                input.css("display", "none");
                container.html(response);
            } else { // data
                container.html(container.html() + response);
                var count = jQuery("#posts-container article").length;
                container.data("offset", count);
                if (count < 6 || (count - offset) < 6) {
                    input.css("display", "none");
                }
            }
            input.removeClass("loading-upper");
            container.removeClass("loading");
        });
    });

    jQuery("#load-more-books").click(function () {
        loadMoreBooks(jQuery(this), false);
    });

    jQuery("#select-sort-books").selectric().on("change", function () {
        var input = jQuery(this);
        var container = jQuery("#books-container");
        container.data("offset", 0);
        container.data("sort-id", input.val());
        container.html(null);
        jQuery("#load-more-books").css("display", "none");
        loadMoreBooks(input, true);
        jQuery("#books-title-header").text(jQuery("#books-title-header").data("title-" + input.val()));
    });

    function loadMoreBooks(input) {
        var button = jQuery("#load-more-books");
        var container = jQuery("#books-container");
        var offset = container.data("offset");
        if (offset < 0) {
            return;
        }
        var sortId = container.data("sort-id");

        input.addClass("loading-upper");
        container.addClass("loading");

        data = {
            action: "kt_grd_load_more_books",
            kt_offset: offset,
            kt_category_id: container.data("category-id"),
            kt_sort_id: sortId
        };

        jQuery.post(myAjax.ajaxurl, data, function (response) {
            if (response == null || response == false) { // empty
                input.css("display", "none");
            } else if (response.indexOf("<p") == 0) { // no results
                input.css("display", "none");
                container.html(response);
            } else { // data
                container.html(container.html() + response);
                var count = jQuery("#books-container article").length;
                container.data("offset", count);
                button.css("display", "inline-block");
                if (count < 9 || (count - offset) < 9) {
                    button.css("display", "none");
                }
                if (sortId && sortId > 1) {
                    addOrUpdateUrlParameterValue("sortId", sortId);
                } else {
                    removeUrlParameter("sortId");
                }
            }
            input.removeClass("loading-upper");
            container.removeClass("loading");
        });
    }
});
